<template>
  <div
    ref="toast"
    class="toast"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
    data-delay="5000"
  >
    <div class="toast-header">
      <!-- <img src="..." class="rounded mr-2" alt="..."> -->
      <strong class="mr-auto">{{ title }}</strong>
      <small class="text-muted">{{ timeAgo }}</small>
      <button
        type="button"
        class="ml-2 mb-1 close"
        data-dismiss="toast"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div
      class="toast-body"
      v-html="message"
    />
  </div>
</template>

<script>
import $ from 'jquery';

export default {
    name: 'BaseToast',
    props: {
        title: {
            type: String,
            default: 'Notification',
        },
        message: {
            type: String,
            default: '',
        },
        time: {
            type: Number,
            default: null,
        },
    },
    computed: {
        timeAgo() {
            if (this.time) {
                return this.$moment(this.time).fromNow();
            }
            return '';
        },
    },
    mounted() {
        $(this.$refs.toast).toast('show');

        $(this.$refs.toast).on('hidden.bs.toast', () => {
            this.$store.dispatch('notifications/remove', this.time);
        });
    },
};
</script>

<style lang="scss">
.toast{
    min-width: 250px;
}
</style>
